import React from 'react'
import AddIcon from 'react-icons/lib/md/add'
import RemoveIcon from 'react-icons/lib/md/remove'
import Button from '@components/Button'
import {EVENTS, sendPosthogData} from '@helpers/posthog'
import FormatNumber from '@i18n/formatNumber/Component'
import Tooltip from '@packages/justo-parts/lib/components/Tooltip'
import UpdateBasicOptions from '@page-components/Order/Options/UpdateBasicOptions'
import get from 'lodash/get'
import {TFunction, withTranslation} from 'next-i18next'

import {getProductDetailsWeb_cached_product} from '../__generated__/getProductDetailsWeb_cached'

import Delete from './Delete'

import styles from './styles.module.css'

const translatePrefix = 'order.products.productsContent.selectProduct.inner.actions'

export interface ActionsProps {
  state: any
  resume: any
  add: Function
  close: Function
  onChange: Function
  product: getProductDetailsWeb_cached_product
  preferences: any
  cartItem: any
  isOutOfStock: boolean
  t: TFunction
  isAddingToCart: boolean
}

export class Actions extends React.Component<ActionsProps> {
  renderButton(adds, {maxPurchaseQuantity, cartItem}) {
    const Icon = adds ? AddIcon : RemoveIcon
    const diff = adds ? 1 : -1
    return (
      <div
        className={styles.amountButton}
        onClick={() => {
          const amount = this.props.state.amount + diff
          sendPosthogData(EVENTS.clicked.productChangeAmount, {
            adds,
            amount,
            ...this.props.product
          })

          if (amount === 0) return
          if (maxPurchaseQuantity && amount > maxPurchaseQuantity) return
          if (cartItem && cartItem.amount + amount > maxPurchaseQuantity) return
          this.props.onChange({amount: amount})
        }}>
        <Icon size={20} />
      </div>
    )
  }

  renderPrice() {
    const {price} = this.props.resume
    if (!price) return null

    return <FormatNumber value={Math.max(price, 0)} />
  }

  renderNoStore() {
    const {preferences} = this.props
    if (!preferences) return null
    return (
      <div className={styles.options}>
        <div>{this.props.t(`${translatePrefix}.labelAddAddressOrSelectStore`)}</div>
        <br />
        <div>
          <UpdateBasicOptions preferences={preferences} />
        </div>
      </div>
    )
  }

  renderNotAvailable() {
    const {product} = this.props

    const message =
      product.availabilityAt.notAvailableMessage ||
      this.props.t(`${translatePrefix}.labelProductNotAvailable`)
    return (
      <div className={styles.container}>
        <div className={styles.outOfStockMessage}>{message}</div>
        {this.renderDelete()}
      </div>
    )
  }

  renderAddButton() {
    const tooltipText = this.props.cartItem ? 'edit' : 'add'
    return (
      <Button
        loading={this.props.isAddingToCart}
        className={styles.button}
        primary
        onClick={() => {
          this.props.add()
          if (this.props.cartItem) {
            sendPosthogData(EVENTS.clicked.saveEditProduct, {...this.props.product})
          }
        }}>
        <Tooltip
          content={
            !this.props.resume.ready ? this.props.t(`${translatePrefix}.labelCompleteAll`) : null
          }>
          {this.props.t(`fields.${tooltipText}`, {ns: 'generic'})}
        </Tooltip>
      </Button>
    )
  }

  renderOutOfStock() {
    return (
      <div className={styles.container}>
        <div className={styles.outOfStockMessage}>
          {this.props.t(`${translatePrefix}.labelProductOutOfStock`)}
        </div>
        {this.renderDelete()}
      </div>
    )
  }

  renderMaxPurchaseQuantity(maxPurchaseQuantity) {
    return (
      <div className={styles.container}>
        <div className={styles.outOfStockMessage}>
          {this.props.t(`${translatePrefix}.labelMaxPurchaseQuantity`, {max: maxPurchaseQuantity})}
        </div>
        {this.renderDelete()}
      </div>
    )
  }

  renderDelete() {
    if (!this.props.cartItem) return null
    return <Delete cartItem={this.props.cartItem} close={this.props.close} />
  }

  render() {
    const {amount} = this.props.state
    const {product, isOutOfStock, preferences} = this.props
    const {maxPurchaseQuantity} = product
    const cartItems = get(preferences, 'cart.items', [])
    const cartItem = cartItems.find(item => item.product._id === product._id)

    if (isOutOfStock) return this.renderOutOfStock()
    if (!product.availabilityAt) return this.renderNoStore()
    if (!product.availabilityAt.available) return this.renderNotAvailable()
    if (cartItem && maxPurchaseQuantity && cartItem.amount >= maxPurchaseQuantity)
      return this.renderMaxPurchaseQuantity(maxPurchaseQuantity)
    return (
      <div className={styles.container}>
        <div className={styles.inner}>
          <div className={styles.amount}>
            {this.renderButton(false, {maxPurchaseQuantity, cartItem})}
            <div className={styles.amountValue}>{amount}</div>
            {this.renderButton(true, {maxPurchaseQuantity, cartItem})}
          </div>
          {this.renderAddButton()}
          <div className={styles.price}>{this.renderPrice()}</div>
        </div>
        {this.renderDelete()}
      </div>
    )
  }
}

export default withTranslation()(Actions)
